import { EntriesTableSettings } from "../../../model/entries-table-settings/EntriesTableSettings";
import { EntriesTableMainFields } from "../../../model/entries-table-settings/types/EntriesTableMainFields.enum";

/** Whether the user may hide this column - the primary fields and the ones flagged `toggleAble: false` always stay. */
export const canHideTableColumn = (
  column: EntriesTableSettings["columns"][number],
): boolean =>
  column.toggleAble !== false &&
  !Object.values(EntriesTableMainFields).includes(
    column.field as EntriesTableMainFields,
  );

/**
 * Number of data rows in a CSV string, header row excluded. Quote-aware, so a
 * line break inside a quoted value (a multi-line description, say) isn't
 * counted as another record.
 */
export const countCsvRows = (csv: string): number => {
  let lines = 0;
  let inQuotes = false;
  let hasPendingLine = false;

  for (const char of csv) {
    if (char === '"') {
      // An escaped quote ("") toggles twice, which nets out to still-inside.
      inQuotes = !inQuotes;
      hasPendingLine = true;
    } else if (char === "\n" && !inQuotes) {
      lines += 1;
      hasPendingLine = false;
    } else {
      hasPendingLine = true;
    }
  }

  // The last record may not be newline-terminated.
  if (hasPendingLine) {
    lines += 1;
  }

  return Math.max(lines - 1, 0);
};
